import Header from "@/pages/home/components/Header";
import Footer from "@/pages/home/components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main className="pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-50 mb-4">
            Politique de confidentialité
          </h1>
          <p className="text-foreground-400 mb-12">
            Dernière mise à jour : 17 juin 2026
          </p>

          <div className="space-y-12">
            {/* Introduction */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                1. Introduction
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Melio LM (ci-après « nous », « notre » ou « nos ») s&rsquo;engage à protéger
                votre vie privée et vos données personnelles. La présente politique de
                confidentialité décrit comment nous collectons, utilisons, stockons et
                protégeons vos données personnelles lorsque vous utilisez notre site web,
                conformément à la Loi fédérale suisse sur la protection des données (nLPD) et
                au Règlement général sur la protection des données (RGPD) de l&rsquo;Union
                européenne lorsque applicable.
              </p>
              <p className="text-foreground-300 leading-relaxed">
                En utilisant notre site, vous acceptez les pratiques décrites dans cette
                politique. Nous vous invitons à la lire attentivement.
              </p>
            </section>

            {/* Responsable du traitement */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                2. Responsable du traitement
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Le responsable du traitement des données est :
              </p>
              <div className="text-foreground-300 leading-relaxed space-y-1">
                <p><strong className="text-foreground-50">Melio LM</strong></p>
                <p>Vevey, Suisse</p>
                <p>Téléphone : <a href="tel:+41797612277" className="text-primary-500 hover:text-primary-400 transition-colors">+41 79 761 22 77</a></p>
              </div>
            </section>

            {/* Données collectées */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                3. Données que nous collectons
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Nous collectons différents types de données en fonction de votre
                interaction avec notre site :
              </p>

              <h3 className="font-heading text-xl font-semibold text-foreground-50 mt-6 mb-3">
                3.1 Données fournies volontairement
              </h3>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-2">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone</li>
                <li>Contenu des messages envoyés via notre formulaire de contact</li>
              </ul>

              <h3 className="font-heading text-xl font-semibold text-foreground-50 mt-6 mb-3">
                3.2 Données collectées automatiquement
              </h3>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-2">
                <li>Adresse IP</li>
                <li>Type de navigateur et version</li>
                <li>Système d&rsquo;exploitation</li>
                <li>Pages visitées et durée de visite</li>
                <li>Données de navigation (cookies)</li>
              </ul>
            </section>

            {/* Finalités du traitement */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                4. Finalités du traitement
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Nous utilisons vos données pour les finalités suivantes :
              </p>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-2">
                <li><strong className="text-foreground-50">Répondre à vos demandes</strong> — traiter et répondre aux messages envoyés via notre formulaire de contact.</li>
                <li><strong className="text-foreground-50">Améliorer notre site</strong> — analyser l&rsquo;utilisation du site pour optimiser l&rsquo;expérience utilisateur.</li>
                <li><strong className="text-foreground-50">Garantir la sécurité</strong> — protéger notre site contre les utilisations frauduleuses ou abusives.</li>
                <li><strong className="text-foreground-50">Obligations légales</strong> — répondre à nos obligations légales et réglementaires en Suisse.</li>
              </ul>
            </section>

            {/* Cookies */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                5. Cookies et technologies similaires
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Notre site utilise des cookies pour améliorer votre navigation et
                analyser l&rsquo;audience. Les cookies sont de petits fichiers texte
                stockés sur votre appareil lors de votre visite.
              </p>

              <h3 className="font-heading text-xl font-semibold text-foreground-50 mt-6 mb-3">
                5.1 Types de cookies utilisés
              </h3>
              <div className="space-y-4">
                <div className="bg-background-50/50 rounded-xl p-5">
                  <h4 className="font-semibold text-foreground-50 mb-2">Cookies nécessaires</h4>
                  <p className="text-foreground-300 leading-relaxed">
                    Indispensables au bon fonctionnement du site. Ils ne peuvent pas être
                    désactivés. Ils incluent par exemple la mémorisation de vos préférences
                    de confidentialité.
                  </p>
                </div>
                <div className="bg-background-50/50 rounded-xl p-5">
                  <h4 className="font-semibold text-foreground-50 mb-2">Cookies analytiques</h4>
                  <p className="text-foreground-300 leading-relaxed">
                    Nous aident à comprendre comment les visiteurs interagissent avec le site
                    en collectant des informations anonymes sur les pages visitées et le temps
                    passé.
                  </p>
                </div>
              </div>

              <h3 className="font-heading text-xl font-semibold text-foreground-50 mt-6 mb-3">
                5.2 Gestion des cookies
              </h3>
              <p className="text-foreground-300 leading-relaxed">
                Vous pouvez à tout moment modifier vos préférences en matière de cookies via
                le lien « Gestion des cookies » disponible dans le pied de page de notre site.
                Vous pouvez également configurer votre navigateur pour bloquer ou supprimer les
                cookies.
              </p>
            </section>

            {/* Base légale */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                6. Base légale du traitement
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Nous traitons vos données personnelles sur les bases légales suivantes :
              </p>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-2">
                <li>Votre consentement explicite (article 6, al. 1, let. a nLPD)</li>
                <li>L&rsquo;exécution d&rsquo;un contrat ou de mesures précontractuelles (article 6, al. 1, let. b nLPD)</li>
                <li>Notre intérêt légitime à améliorer nos services (article 6, al. 1, let. f nLPD)</li>
                <li>Le respect d&rsquo;obligations légales (article 6, al. 1, let. c nLPD)</li>
              </ul>
            </section>

            {/* Conservation */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                7. Durée de conservation
              </h2>
              <p className="text-foreground-300 leading-relaxed">
                Nous conservons vos données personnelles uniquement pendant la durée
                nécessaire aux finalités pour lesquelles elles ont été collectées, ou
                pour nous conformer à nos obligations légales. Les données de contact
                sont conservées pendant une durée maximale de 2 ans après le dernier
                échange. Les données analytiques anonymisées peuvent être conservées
                indéfiniment.
              </p>
            </section>

            {/* Sécurité */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                8. Sécurité des données
              </h2>
              <p className="text-foreground-300 leading-relaxed">
                Nous mettons en œuvre des mesures techniques et organisationnelles
                appropriées pour protéger vos données personnelles contre tout accès
                non autorisé, perte, divulgation, altération ou destruction. Notre site
                utilise le protocole HTTPS pour chiffrer les données en transit. L&rsquo;accès
                à vos données est strictement limité aux personnes autorisées.
              </p>
            </section>

            {/* Partage */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                9. Partage des données
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Nous ne vendons, n&rsquo;échangeons ni ne louons vos données personnelles à
                des tiers. Nous pouvons partager vos données dans les cas suivants :
              </p>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-2">
                <li><strong className="text-foreground-50">Prestataires de services</strong> — nos sous-traitants techniques (hébergement, analyse) qui agissent selon nos instructions.</li>
                <li><strong className="text-foreground-50">Obligation légale</strong> — si la loi l&rsquo;exige ou pour protéger nos droits.</li>
                <li><strong className="text-foreground-50">Avec votre consentement</strong> — dans tous les autres cas, nous vous demanderons votre accord préalable.</li>
              </ul>
            </section>

            {/* Transferts internationaux */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                10. Transferts internationaux
              </h2>
              <p className="text-foreground-300 leading-relaxed">
                Vos données sont hébergées en Suisse et dans l&rsquo;Espace économique
                européen. Si un transfert de données devait avoir lieu vers un pays ne
                bénéficiant pas d&rsquo;un niveau de protection adéquat, nous mettrions en
                place les garanties appropriées conformément à la nLPD et au RGPD.
              </p>
            </section>

            {/* Droits */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                11. Vos droits
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Conformément à la nLPD et au RGPD, vous disposez des droits suivants :
              </p>
              <ul className="list-disc pl-6 text-foreground-300 leading-relaxed space-y-3">
                <li><strong className="text-foreground-50">Droit d&rsquo;accès</strong> — obtenir la confirmation que vos données sont traitées et en recevoir une copie.</li>
                <li><strong className="text-foreground-50">Droit de rectification</strong> — faire corriger des données inexactes ou incomplètes.</li>
                <li><strong className="text-foreground-50">Droit à l&rsquo;effacement</strong> — demander la suppression de vos données dans certaines conditions.</li>
                <li><strong className="text-foreground-50">Droit à la limitation</strong> — restreindre le traitement de vos données dans certains cas.</li>
                <li><strong className="text-foreground-50">Droit d&rsquo;opposition</strong> — vous opposer au traitement fondé sur l&rsquo;intérêt légitime.</li>
                <li><strong className="text-foreground-50">Droit à la portabilité</strong> — recevoir vos données dans un format structuré et couramment utilisé.</li>
                <li><strong className="text-foreground-50">Droit de retrait du consentement</strong> — retirer votre consentement à tout moment.</li>
              </ul>
              <p className="text-foreground-300 leading-relaxed mt-4">
                Pour exercer vos droits, contactez-nous par email ou par téléphone aux
                coordonnées indiquées en section 2. Nous répondrons à votre demande dans
                un délai maximum de 30 jours.
              </p>
            </section>

            {/* Réclamations */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                12. Droit de réclamation
              </h2>
              <p className="text-foreground-300 leading-relaxed">
                Si vous estimez que le traitement de vos données personnelles n&rsquo;est
                pas conforme à la législation applicable, vous avez le droit
                d&rsquo;introduire une réclamation auprès de l&rsquo;autorité de protection
                des données compétente :
              </p>
              <div className="bg-background-50/50 rounded-xl p-5 mt-4">
                <p className="text-foreground-300 leading-relaxed">
                  <strong className="text-foreground-50">Préposé fédéral à la protection des données et à la transparence (PFPDT)</strong><br />
                  Feldeggweg 1, 3003 Berne, Suisse<br />
                  <a href="https://www.edoeb.admin.ch" target="_blank" rel="noopener noreferrer" className="text-primary-500 hover:text-primary-400 transition-colors">
                    www.edoeb.admin.ch
                  </a>
                </p>
              </div>
            </section>

            {/* Modifications */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                13. Modifications de cette politique
              </h2>
              <p className="text-foreground-300 leading-relaxed">
                Nous nous réservons le droit de modifier cette politique de confidentialité
                à tout moment. Les modifications entrent en vigueur dès leur publication
                sur cette page. Nous vous encourageons à consulter régulièrement cette
                page pour vous tenir informé des éventuelles mises à jour.
              </p>
            </section>

            {/* Contact */}
            <section className="bg-background-100 rounded-2xl p-8 md:p-10">
              <h2 className="font-heading text-2xl font-semibold text-foreground-50 mb-4">
                14. Contact
              </h2>
              <p className="text-foreground-300 leading-relaxed mb-4">
                Pour toute question relative à cette politique de confidentialité ou au
                traitement de vos données personnelles, n&rsquo;hésitez pas à nous contacter :
              </p>
              <div className="text-foreground-300 leading-relaxed space-y-1">
                <p><strong className="text-foreground-50">Melio LM</strong></p>
                <p>Vevey, Suisse</p>
                <p>Téléphone : <a href="tel:+41797612277" className="text-primary-500 hover:text-primary-400 transition-colors">+41 79 761 22 77</a></p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}